// extracted by mini-css-extract-plugin
export default {"main":"PostPurchasePage-module__main--nE5Fk"};